import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Relations = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
      <Route
        path={`${match.url}/list`}
        component={asyncComponent(() => import("./routes/list"))}
      />
      <Route
        path={`${match.url}/groups`}
        component={asyncComponent(() => import("./routes/groups"))}
      />
      <Route
        path={`${match.url}/filter`}
        component={asyncComponent(() => import("./routes/filter"))}
      />
      <Route
        path={`${match.url}/import`}
        component={asyncComponent(() => import("./routes/import"))}
      />
      <Route
        component={asyncComponent(() =>
          import("app/routes/extraPages/routes/404")
        )}
      />
    </Switch>
  </div>
);

export default Relations;
